import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const getURL = () => {
  let url =
    import.meta?.env?.VITE_SITE_URL ?? // Set this to your site URL in production env.
    import.meta?.env?.VITE_VERCEL_URL ?? // Automatically set by Vercel.
    'http://localhost:5173';
  // Make sure to include `https://` when not localhost.
  url = url.includes('http') ? url : `https://${url}`;
  // Ensure the URL does not end with a trailing slash to prevent broken links (e.g., https://site.com//auth)
  return url.replace(/\/$/, '');
};
